import o from "./logger.js";
var r = function r(_r, t) {
    return o.e("react-sdk", t, _r);
  },
  t = function t(o) {
    throw o;
  };
export { r as logErrorHandler, t as throwErrorHandler };